/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Illegal_LabelInputs */



/**
* | output |
* | --- |
* | "Illegal" |
*
* @param {Event_Warning_Illegal_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_illegal_label = /** @type {((inputs?: Event_Warning_Illegal_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Illegal_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Illégal")
	if (locale === "de") return /** @type {LocalizedString} */ ("Illegal")
	if (locale === "it") return /** @type {LocalizedString} */ ("Illegale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Незаконно")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ilegal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("非法的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("違法")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गैरकानूनी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ilegal")
	return /** @type {LocalizedString} */ ("Illegal")
});